module.exports = __webpack_public_path__ + "img/lg_ring_g_0_0_1@2x.1ab942f1.png";